module.exports = __webpack_public_path__ + "img/BlueLikesIcon.efc2f207.svg";